// extracted by mini-css-extract-plugin
export default {"container":"category_container__3nOFs","link":"category_link__1qkDY"};